<template>
  
  <vue-tailwind-modal
    :showing="showModal"
    @close="$emit('close-modal')"
    :showClose="true"
    :backgroundClose="false"
    class='p-4'
  >
    <narrative-settings-form 
      title="Change Narrative Settings"
      description=""
      submit-button-text="Save"
      :loading="loading"
      :username="username"
      :narrative="narrative"
      :isNewNarrative="false"
      @save="onNarrativeSaved"
    />
  </vue-tailwind-modal>
</template>

<script>
import CButton from '@/components/Core/CButton'
import NarrativeSettingsForm from '@/views/Narratives/components/NarrativeSettingsForm.vue'

export default {
  components: {
    CButton,
    NarrativeSettingsForm
  },
  props: ["showModal", 'loading', 'narrative', 'username'],
  methods: {
      onNarrativeSaved(narrative) {
          this.$emit('save', narrative);
      }
  }
}
</script>
